// extracted by mini-css-extract-plugin
export default {"recos":"p2-z","productCardOverride":"q2-z","rowHasBadge":"r2-z"};